import React, { useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
// import { EMPOWER_LOGIN_URL } from "../config";

const Auth = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // fetch(`${EMPOWER_LOGIN_URL}/is_user_logged`, {
    //   method: "GET",
    //   credentials: "include",
    // })
    //   .then(async (res) => {
    //     if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    //     return res.json();
    //   })
    //   .then((data) => {
    //     console.log(data);

    //     if (data.status === "ok") {
    //       setAuthenticated(true);
    //       setUser(data.user);
    //     } else {
    //       window.location.href = EMPOWER_LOGIN_URL;
    //     }
    //   })
    //   .catch((err) => {
    //     console.error("Error checking session:", err);
    //     window.location.href = EMPOWER_LOGIN_URL;
    //   })
    //   .finally(() => setLoading(false));
    const data = { status: 'ok', user: { employee_code: '51010121', employee_name: 'Avi', is_sop_admin: 1, is_consensus_admin: 1 } };
    setAuthenticated(true);
    setUser(data.user);
    setLoading(false);
  }, []);

  if (loading) return <div data-testid="auth-loading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#F4F4F5', fontFamily: "'IBM Plex Mono', monospace", fontSize: '0.85rem', fontWeight: 600, color: '#52525B', textTransform: 'uppercase', letterSpacing: '0.15em' }}>LOADING_</div>;
  if (!authenticated) return null;

  return (
    <AuthContext.Provider value={{ user, setUser, authenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export default Auth;
